import { JobOperationType } from './enums';

export default class JobOperation {
  public id: number;
  public isFailure: boolean;
  public jobId: number;
  public operationType: JobOperationType;
  public operationDateTime: Date;
  public requestedByUserId: string;

  constructor(
    isFailure?: boolean,
    jobId?: number,
    operationType?: JobOperationType,
    operationDateTime?: Date,
    requestedByUserId?: string,
    id?: number,
  ) {
    this.id = id || 0;
    this.isFailure = isFailure || false;
    this.jobId = jobId || 0;
    this.operationType = operationType || JobOperationType.Stopped;
    this.operationDateTime = operationDateTime || new Date();
    this.requestedByUserId = requestedByUserId || '';
  }
}
